import { useLocation, useParams } from "react-router-dom";
import style from "./MachineManagement.module.css";
import { useEffect, useState } from "react";
import { requester } from "App";
import { Draggable, DragDropContext, Droppable } from "react-beautiful-dnd";
import StoreProductCard from "./StoreProductCard";
import P from "components/P";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import Center from "layouts/wrapper/Center";
import VerticalFlex from "layouts/flex/VerticalFlex";
import CustomButton from "components/buttons/CustomButton";
import Dummy from "components/Dummy";
import { toast } from "react-toastify";
import Container from "layouts/container/Container";

function MachineManagement() {
    const location = useLocation();
    const { machineId } = useParams();
    const [storeProducts, setStoreProducts] = useState([]);
    const [machineType, setMachineType] = useState("기계의 타입을 선택해주세요");
    const [cells, setCells] = useState(Array(80).fill(null));
    const [vendingName, setVendingName] = useState();
    const [placedItems, setPlacedItems] = useState([]);


    useEffect(() => {
        if (location.state?.data?.storeId) {
            const data = { storeId: location.state.data.storeId };
            const currentMachineId = location.state.data.id; // 현재 페이지의 기계 ID

            setVendingName(location.state.data.vendingName);
            requester.findAllProductsByStore(data, (result) => {
                // 현재 기계의 ID와 일치하는 상품만 필터링
                if (result.data && result.data.length > 0) {
                    
                    
                    const filteredProducts = result.data.filter(product => product.machineId === currentMachineId);
                    
                    // 현재 기계 ID와 일치하지 않는 상품들
                    const otherProducts = result.data.filter(product => product.machineId !== currentMachineId);
                    setStoreProducts(otherProducts);
                    // 셀 초기화: 예시에서는 모든 셀을 null로 초기화합니다.
                    // 기계 타입에 따라 셀의 크기를 변경할 수 있습니다.
                    let initialCells = Array(80).fill(null); // 80은 기계 타입에 따라 동적으로 결정될 수 있습니다.
                    // filteredProducts를 반복하면서 각 상품을 셀 배열에 위치시킵니다.
                    filteredProducts.forEach(product => {
                        if (product.locationNo !== null && product.locationNo <= initialCells.length) {
                            initialCells[product.locationNo - 1] = product; // locationNo는 1부터 시작한다고 가정
                        }
                    });
                    setCells(initialCells);
                    setPlacedItems(filteredProducts.length > 0 && filteredProducts);
                    setMachineType(filteredProducts.length > 0 && filteredProducts[0].machineType);
                }

                // 기계 ID와 일치하지 않는 상품들을 다른 상태에 저장할 수 있습니다.
            });
        }
    }, [location]);

    const itemsPerPage = 30;
    const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
        // 페이지 변경시 scrollTop 조정을 통해 사용자에게 시각적으로 페이지가 변경되었음을 인지시킬 수 있음
        window.scrollTo(0, 0);
    }, [currentPage]);

    useEffect(() => {
        if (placedItems) {
            
        }
    }, [placedItems])

    const pageCount = Math.ceil(cells.length / itemsPerPage);
    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = currentPage * itemsPerPage;
    const currentCells = cells.slice(indexOfFirstItem, indexOfLastItem);

    const handlePageClick = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const onDragEnd = (result) => {
        const { source, destination } = result;
        if (!destination) return;

        // 기계 타입이 올바르게 설정되지 않았을 경우, 경고 메시지 표시
        if (machineType === "기계 타입을 선택하세요") {
            toast.error("상품을 이동하기 전에 기계 타입을 선택해주세요.", {
                autoClose: 3000,
                position: toast.POSITION.TOP_CENTER
            });
            return; // 함수 실행 종료
        }

        if (source.droppableId === destination.droppableId && source.index === destination.index) {
            return;
        }

        let newCells = [...cells];
        let newStoreProducts = [...storeProducts];

        // 셀에서 셀로 이동
        if (source.droppableId.startsWith("cell") && destination.droppableId.startsWith("cell")) {
            const sourceIndexGlobal = parseInt(source.droppableId.replace("cell-", ''), 10);
            const destIndexGlobal = parseInt(destination.droppableId.replace("cell-", ''), 10);


            [newCells[sourceIndexGlobal], newCells[destIndexGlobal]] = [newCells[destIndexGlobal], newCells[sourceIndexGlobal]];

            // 위치 변경 로직
            const updatedPlacedItems = placedItems.map(item => {
                if (item.locationNo === sourceIndexGlobal + 1) {
                    return { ...item, locationNo: destIndexGlobal + 1 };
                } else if (item.locationNo === destIndexGlobal + 1) {
                    return { ...item, locationNo: sourceIndexGlobal + 1 };
                }
                return item;
            });

            setPlacedItems(updatedPlacedItems);
        }
        // 미등록에서 셀로 이동
        else if (source.droppableId === "unregisteredItems" && destination.droppableId.startsWith("cell")) {
            const destIndex = parseInt(destination.droppableId.replace("cell-", ''), 10);
            const draggedItem = newStoreProducts[source.index];

            // 목적지 셀에 이미 상품이 있는 경우, 그 상품을 미등록 목록으로 이동
            if (newCells[destIndex]) {
                newStoreProducts.push(newCells[destIndex]);
            }
            // 새 위치에 드래그된 아이템을 할당
            newCells[destIndex] = draggedItem;
            // 드래그된 아이템을 미등록 목록에서 제거
            newStoreProducts.splice(source.index, 1);
            // 새로운 상태에 이동된 데이터 추가 (중복 제외)
            // setPlacedItems(currentItems => [
            //     ...currentItems.filter(item => item.locationNo !== destIndex + 1),
            //     { ...draggedItem, locationNo: destIndex + 1, machineId: machineId, machineType: machineType }
            // ]);
            setPlacedItems(currentItems => {
                
                if (!Array.isArray(currentItems)) {
                
                    return []; // 비상 대비책: 기본 배열 반환
                }
                return [
                    ...currentItems.filter(item => item.locationNo !== destIndex + 1),
                    { ...draggedItem, locationNo: destIndex + 1, machineId: machineId, machineType: machineType }
                ];
            });
        }
        // 셀에서 미등록으로 이동
        else if (source.droppableId.startsWith("cell") && destination.droppableId === "unregisteredItems") {
            const sourceIndex = parseInt(source.droppableId.replace("cell-", ''), 10);
            const movedItem = newCells[sourceIndex];
            // 목적지(미등록)에 아이템 추가
            newStoreProducts.push(movedItem);
            const updatedPlacedItems = placedItems.filter(item => item.id !== movedItem.id);
            setPlacedItems(updatedPlacedItems);
            newCells[sourceIndex] = null;


        }

        setCells(newCells);
        setStoreProducts(newStoreProducts);
    };


    // 아이템을 렌더링하는 함수를 별도로 분리하여, 코드의 재사용성과 가독성을 높임
    const renderCellItem = (item, index) => {
        if (!item) return null;

        return (
            <Draggable key={item.id} draggableId={item.id.toString()} index={index}>
                {(provided) => (
                    <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        className={style.draggableItem}
                    >
                        <Center>
                            <img src={item.productImg} alt={item.productName} height="100px" />
                            <p>{item.productName}</p>
                        </Center>
                    </div>
                )}
            </Draggable>
        )
    };

    const updateClick = () => {

        if (!machineType) {

            toast.error("기계의 타입을 선택해주세요", {
                autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
            });

        } else {
            let machineData = { machineId: machineId, storeProducts: placedItems };
            requester.mappingMachineProductList(machineData, (result) => {

                if (result.code === 0) {
                    toast.success("수정이 완료되었습니다", {
                        autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                    });
                } else {
                    toast.error("스토어 머신에 중복된 상품을 넣을 수 없습니다.", {
                        autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                    });
                }
            })
        }

    }

    const machineTypeChange = (e) => {

        const selectedMachineType = e.target.value;
        setMachineType(e.target.value);

        let newCellsSize;
        if (e.target.value === "A") {
            newCellsSize = 80;
        } else if (e.target.value === "B") {
            newCellsSize = 50;
        } else {
            newCellsSize = 0; // 또는 기본 크기 설정
        }

        // 현재 셀에 배치된 상품들을 "미등록" 목록으로 이동
        const currentlyPlacedItems = cells.filter(cell => cell !== null);
        const updatedUnregisteredItems = [...storeProducts, ...currentlyPlacedItems];

        // 새로운 기계 타입에 따라 셀 배열을 재설정
        setCells(Array(newCellsSize).fill(null));
        // "미등록" 목록 업데이트
        setStoreProducts(updatedUnregisteredItems);
        // 배치된 아이템 목록 초기화
        setPlacedItems([]);

        if (selectedMachineType === "기계 타입을 선택하세요") {
            // 셀과 placedItems에 있는 모든 상품을 미등록 목록으로 되돌림
            const itemsToUnregister = [...cells.filter(cell => cell !== null), ...placedItems.map(item => item.storeProduct)].filter(Boolean);
            // setStoreProducts(prevStoreProducts => [...prevStoreProducts, ...itemsToUnregister]);
            setStoreProducts(prevStoreProducts => {
                // 새로운 상품 목록을 생성하기 위해 중복을 제거한 후 이전 상품 목록과 결합
                const newItems = itemsToUnregister.filter((unregisteredItem) =>
                    !prevStoreProducts.some((product) => product.id === unregisteredItem.id)
                );

                return [...prevStoreProducts, ...newItems];
            });
            // 셀과 placedItems 초기화
            setCells(Array(80).fill(null)); // 기본 셀 상태로 초기화
            setPlacedItems([]);
        } else {
            // A 또는 B 타입에 따라 셀의 크기를 조정
            let newSize = selectedMachineType === "A" ? 80 : 50;
            setCells(Array(newSize).fill(null));
            // 이 경우, placedItems에 대한 처리를 별도로 추가할 수 있음
        }
    };
    return (
        <Container>
            <Container maxWidth={1200}>
                <Center width={"100%"} textAlign={"left"}>
                    <P size={40} font={"gmarketSansBold"} color={"black"}>{vendingName && vendingName}</P>

                </Center>
                <P size={20} weight={"bold"}>기계 타입</P>
                <select onChange={machineTypeChange} value={machineType}>
                    <option>기계 타입을 선택하세요</option>
                    <option value={"A"}>A</option>
                    <option value={"B"}>B</option>
                </select>
                <DragDropContext onDragEnd={onDragEnd}>
                    <HorizontalFlex>
                        <FlexChild width="20%">
                            <VerticalFlex>
                                {/* '미등록' 영역 */}
                                <FlexChild>
                                    <Droppable droppableId="unregisteredItems">
                                        {(provided) => (
                                            <div {...provided.droppableProps} ref={provided.innerRef} className={style.droppableContainer}>
                                                {storeProducts.map((item, index) => renderCellItem(item, index))}
                                                {provided.placeholder}
                                            </div>
                                        )}
                                    </Droppable>
                                </FlexChild>
                            </VerticalFlex>
                        </FlexChild>

                        {/* '8행 10열 칸반보드' 영역 */}
                        <FlexChild width="80%">
                            <VerticalFlex gap={15}>
                                <div className={style.kanbanBoard}>
                                    {currentCells.map((cell, index) => (
                                        <Droppable key={index} droppableId={`cell-${indexOfFirstItem + index}`}>
                                            {(provided) => (
                                                <div
                                                    ref={provided.innerRef}
                                                    {...provided.droppableProps}
                                                    className={style.kanbanCell}
                                                >
                                                    <P>{indexOfFirstItem + index + 1}</P>
                                                    {cell && renderCellItem(cell, index)}
                                                    {provided.placeholder}
                                                </div>
                                            )}
                                        </Droppable>
                                    ))}
                                </div>
                                {/* 페이지네이션 버튼 */}
                                <div className={style.pagination}>
                                    {Array.from({ length: pageCount }, (_, i) => (
                                        <button
                                            key={i}
                                            onClick={() => handlePageClick(i + 1)}
                                            className={currentPage === i + 1 ? style.active : ''}
                                        >
                                            {i + 1}
                                        </button>
                                    ))}
                                </div>
                            </VerticalFlex>
                        </FlexChild>
                    </HorizontalFlex>
                </DragDropContext>
                <Dummy height={"15px"} />
                <FlexChild>
                    <Center>
                        <CustomButton text={"적용"} onClick={updateClick} />
                    </Center>
                </FlexChild>
            </Container>
        </Container>

    );
}

export default MachineManagement;